import styles from "./RatingStamp.module.css";

export default function RatingStamp({ value }) {
  const has = value != null && Number(value) > 0;
  const shown = has ? Number(value).toFixed(1) : "—";
  return (
    <span
      className={styles.stamp}
      aria-label={has ? `rating ${Number(value).toFixed(1)} out of 5` : "not yet rated"}
    >
      <span className={styles.value}>{shown}</span>
      {has && <span className={styles.max}>/5</span>}
    </span>
  );
}
